import { Component, EventEmitter, Output } from '@angular/core';
import { NotificationService } from 'src/app/shared';
import { EventV4RegistrationService } from 'src/app/events-v4/shared/registration/event-v4-registration.service';
import { RegistrationMin } from 'src/app/events-v4/shared/registration/registration-min.model';

@Component({
  selector: 'wl-event-v4-create-registration-profile-dialog',
  templateUrl: './event-v4-create-registration-profile-dialog.component.html',
  styleUrl: './event-v4-create-registration-profile-dialog.component.less',
    standalone: false
})
export class EventV4CreateRegistrationProfileDialogComponent {
  @Output() public modalClosed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public modalClosedAndEditRegistration: EventEmitter<RegistrationMin> = new EventEmitter<RegistrationMin>();

  registration: RegistrationMin = {} as RegistrationMin;
  showAssignProfileDialog: boolean = false;
  showQuestionEditRegistrationDialog: boolean = false;
  saving: boolean = false;
  loadingProfile: boolean;
  assignProfileDialogInitialized = false;

  get initialKeyword(): string | undefined {
    const orgName = this.registration?.OrgName?.trim();
    return orgName ? orgName : this.registration?.LastName;
  }

  public constructor(private _registrationService: EventV4RegistrationService, private _notificationService: NotificationService) {}

  public openAssignProfileDialog(registration: RegistrationMin) {
    this.registration = registration;
    this.showAssignProfileDialog = true;
    setTimeout(() => {
      this.assignProfileDialogInitialized = true;
    });
  }

  closeAssignProfileDialog() {
    this.modalClosed.emit(true);
    this.saving = false;
    this.showAssignProfileDialog = false;
  }

  createRegistrationProfile() {
    this.saving = true;
    this._registrationService
      .createRegistrationProfile(this.registration.Id)
      .then(() => {
        this._notificationService.translateSuccess('common.saved-successfully');
        this.closeAssignProfileDialog();
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }

  async assignProfileToRegistration(profileId: number) {
    this._registrationService
      .assignProfileToRegistration(this.registration.Id, profileId)
      .then((profileWasAssigned: boolean) => {
        this.closeAssignProfileDialog();

        if (profileWasAssigned) {
          this._notificationService.translateSuccess('common.saved-successfully');
        } else {
          this.openQuestionEditRegistrationDialog();
        }
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      });
  }

  openQuestionEditRegistrationDialog() {
    this.closeAssignProfileDialog();
    this.showQuestionEditRegistrationDialog = true;
  }

  closeQuestionEditRegistrationDialog() {
    this.showQuestionEditRegistrationDialog = false;
    this.closeAssignProfileDialog();
  }

  goToRegistrationEdit() {
    this.closeQuestionEditRegistrationDialog();
    this.modalClosedAndEditRegistration.emit(this.registration);
  }
}
